import * as React from "react";

export type AiSpinnerProps = {
  size?: "sm" | "md";
  label?: string;
  className?: string;
};

/** CSS-only loading spinner — replaces antd Spin in AI analysis. */
export const AiSpinner: React.FC<AiSpinnerProps> = ({
  size = "md",
  label = "Loading",
  className,
}) => (
  <span
    className={`ai-spinner ai-spinner--${size}${className ? ` ${className}` : ""}`}
    role="status"
    aria-label={label}
  />
);

export default AiSpinner;
